module.exports = __webpack_public_path__ + "img/br7.ba2ae31.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/br7.jpg
// module id = QnmL
// module chunks = 0